module.exports = __webpack_public_path__ + "img/5.930cb157.png";